module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/4-4bbb64754f115d5e3158d0f2668128e9.png";